import React, { useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import {
    IoArrowForwardOutline, IoCloseSharp,
    IoAlertCircleOutline, IoDocumentTextOutline
} from 'react-icons/io5'

const searchResults = [
    { id: 1, text: 'What is Risk in GRC?', icon: <IoAlertCircleOutline className="text-teal-600 w-5 h-5" /> },
    { id: 2, text: 'How to Register a Risk?', icon: <IoAlertCircleOutline className="text-teal-600 w-5 h-5" /> },
    { id: 3, text: 'List of Risk Manager were Assigned...', icon: <IoDocumentTextOutline className="text-gray-600 w-5 h-5" /> }
]

const SearchBar = ({ width = 'w-1/2' }) => {
    const [ query, setQuery ] = useState('')
    const [ filteredResults, setFilteredResults ] = useState([])

    const handleSearch = (e) => {
        const value = e.target.value
        setQuery(value)

        if (value.trim() === '') {
            setFilteredResults([])
        } else {
            const filtered = searchResults?.filter(item =>
                item.text.toLowerCase().includes(value.toLowerCase())
            )
            setFilteredResults(filtered)
        }
    }

    const clearSearch = () => {
        setQuery('')
        setFilteredResults([])
    }

    return (
        <div className="flex justify-center my-4 w-full !relative">
            {/* Search Box */}
            <div className={`flex items-center border-2 border-[#b2d9d8] rounded-md px-8 py-2 ${width} shadow-sm focus-within:border-[#00a2a1] gap-4`}>
                {/* Search Icon */}
                <FaSearch className="text-teal-600 mr-2 w-5 h-5" />

                {/* Input Field */}
                <input
                    type="text"
                    value={query}
                    onChange={handleSearch}
                    placeholder="Search for help topics..."
                    className="w-full outline-none bg-transparent !text-[#333] placeholder-gray-400"
                />

                {/* Arrow Icon */}
                {/* Clear Button */}
                {query
                    ? (<button onClick={clearSearch} className="hover:bg-primary-foreground rounded-full p-2 ml-2 border border-[#fff] hover:border-primary transition-all">
                        <IoCloseSharp className="text-gray-600" />
                    </button>)
                    : (<button className='hover:bg-primary-foreground rounded-full p-2 ml-2 border border-[#fff] hover:border-primary transition-all'>
                        <IoArrowForwardOutline className="text-gray-600" />
                    </button>
                    )}
            </div>

            {/* Dropdown Results */}
            {filteredResults?.length > 0 && (
                <div className={`absolute top-14 mt-2 ${width} bg-[#fff] border border-gray-300 rounded-md shadow-lg overflow-hidden`}>
                    {filteredResults?.map((item) => (
                        <div key={item.id} className="flex items-center px-4 py-3 hover:bg-gray-100 cursor-pointer">
                            {item.icon}
                            <span className="ml-3 text-gray-800">{item.text}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default SearchBar
